
/**
 * @param {string} innerHTML - Toggle buttons innerHTML
 * @param {Element} itemsContainer - itemsContainer element holding all menu items
 * @returns
 */
function createToggle(innerHTML, itemsContainer) {
  
 
  const currentLanguageButton = document.createElement('button');
  currentLanguageButton.type = 'button';
  currentLanguageButton.classList.add('language-navigation__current');
  currentLanguageButton.setAttribute('aria-expanded', 'false');
  currentLanguageButton.innerHTML = innerHTML;

  currentLanguageButton.addEventListener('click', () => {
    if (currentLanguageButton.getAttribute('aria-expanded') === 'false') {
      currentLanguageButton.setAttribute('aria-expanded', 'true');
      itemsContainer.setAttribute('aria-hidden', 'false');
    } else {
      currentLanguageButton.setAttribute('aria-expanded', 'false');
      itemsContainer.setAttribute('aria-hidden', 'true');
    }
  });

  itemsContainer.setAttribute('aria-hidden', 'true');

  return currentLanguageButton;
}

function initLanguageMenu() {
  const languageMenuContainers = document.querySelectorAll('.js-navigation .menu-kielivalikko-container');

  for (const languageMenuContainer of languageMenuContainers) {
    const languageMenuItemsContainer = languageMenuContainer.querySelector('.language-navigation__items');
    const languageMenuItems = languageMenuItemsContainer.querySelectorAll('.menu-item');
    let currentLang = '';

    // If there's no current-menu-item
    const currentMenuItem = languageMenuItemsContainer.querySelector('.menu-item.current-menu-item');
    if (!currentMenuItem) {
      languageMenuItems[0].classList.add('current-menu-item', 'current_page_item');
    }

    for (const menuItem of languageMenuItems) {
      if (menuItem.classList.contains('current-menu-item')) {
        currentLang = menuItem.querySelector('span').querySelector('a').innerHTML;
        menuItem.style.display = 'none';
      }
    }

    languageMenuContainer.prepend(createToggle(currentLang, languageMenuItemsContainer));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initLanguageMenu();
});